import * as React from 'react';
import { SVGProps } from 'react';

const IconMicSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 2a3 3 0 0 0-3 3v6a3 3 0 1 0 6 0V5a3 3 0 0 0-3-3z" />
    <path d="M5 11a7.001 7.001 0 0 0 6 6.93V22h2v-4.07A7.001 7.001 0 0 0 19 11h-2a5 5 0 0 1-10 0H5z" />
  </svg>
);
export default IconMicSizeM;
